import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

// Local loading spinner — mirrors the LoadingState in Organizations.tsx
// (there is no shared spinner component in the repo).
export const LoadingState = () => (
  <div className="flex items-center justify-center py-20">
    <svg className="h-8 w-8 animate-spin text-zinc-400" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  </div>
);

// Standard card chrome around the loading spinner for a tool panel.
export const PanelLoadingCard = () => (
  <div className="mt-6 w-full rounded-lg border-2 border-shadowborder pt-5">
    <LoadingState />
  </div>
);

// Standard card chrome around a failed-fetch message for a tool panel.
export const PanelErrorCard = ({ error }: { error: string | null }) => (
  <div className="mt-6 w-full rounded-lg border-2 border-shadowborder pt-5">
    <div className="flex flex-col items-center justify-center gap-3 py-20">
      <ExclamationTriangleIcon className="h-8 w-8 text-red-400" />
      <p className="max-w-md text-center text-sm font-medium text-red-500">
        {error || "Something went wrong. Please try again."}
      </p>
    </div>
  </div>
);
